module.exports = __webpack_public_path__ + "static/feature-02-98970fe5143684c25db016e5719350cc.png";